import { createAction, createSlice } from '@reduxjs/toolkit';
import { GET_PROJECT_SUCCESS } from '../../constants/actions/project.constants';
import type { IProject } from '../../types';

const getProjectSuccess = createAction<IProject>(GET_PROJECT_SUCCESS);

const NAME = 'surveyProject';

const slice = createSlice({
    name: NAME,
    initialState: null as IProject | null,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getProjectSuccess, (_, action) => action.payload);
    },
});

export default { reducer: slice.reducer, actions: slice.actions };
